import React, {FC} from 'react';

import {Trans} from '../../../../../../../libs/shared/helpers/src/internationalization/react';
import {
  CompanyPreferencesModel,
  PermalinkAccessEnum,
} from '../../../../../../models/api/companyPreferencesModel';

interface PermalinkPermissionTooltipProps {
  preferences: CompanyPreferencesModel;
}

export const PermalinkPermissionTooltip: FC<PermalinkPermissionTooltipProps> = ({preferences}) =>
  preferences.permalinkAccess === PermalinkAccessEnum.ALL_TEAMMATES ? (
    <Trans id="permalink-access-allteammates">
      Anyone in your company with an active Front account will be able to view this link.
    </Trans>
  ) : (
    <Trans id="permalink-access-participantsonly">Only participants will be able to view this link.</Trans>
  );
